import ongs from "./shop";

export const apiShop = ongs;
